import Popup from '../popup/popup';

/**
 * @deprecated use Popup class instead: import { Popup } from 'main.popup'
 */
export default class PopupWindow extends Popup
{

}